
import { defineComponent } from "vue";
import KycVerificationIndexList from "@/components/page/kyc/kyc-verification/IndexList.vue";

export default defineComponent({
  name: "kyc-verification-natural-person",
  components: {
    KycVerificationIndexList,
  },
  setup() {
    return {};
  },
});
